import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle, WarningCircle, XCircle } from "@phosphor-icons/react";

const ACTION = "inline-flex items-center border border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest transition-colors duration-100 hover:bg-black hover:text-white";
const TONE = {
  pass: ["text-emerald-700", CheckCircle], warn: ["text-amber-600", WarningCircle], fail: ["text-red-600", XCircle],
};

export function CheckRow({ c }) {
  const [tone, Icon] = TONE[c.status] || TONE.warn;
  return (
    <li className="flex items-start gap-2 py-2" data-testid={`launch-check-${c.key}`} data-status={c.status}>
      <Icon size={18} weight="fill" className={`mt-0.5 flex-shrink-0 ${tone}`} />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-bold leading-tight">{c.title}</div>
        <div className="text-xs text-zinc-600" data-testid={`launch-check-${c.key}-detail`}>{c.detail}</div>
      </div>
      {c.status !== "pass" && c.link && <Link to={c.link} className={ACTION} data-testid={`launch-check-${c.key}-open`}>Fix</Link>}
    </li>
  );
}

function StepAction({ s, group, onWizard }) {
  const testId = `launch-${group}-${s.key}-open`;
  if (s.wizard) return <button type="button" className={ACTION} onClick={onWizard} data-testid={testId}>Open wizard</button>;
  if (s.link) return <Link to={s.link} className={ACTION} data-testid={testId}>Open</Link>;
  return null;
}

export function StepList({ title, name, steps, group, onWizard }) {
  const next = steps.findIndex((s) => !s.done);
  return (
    <div data-testid={`launch-${group}-steps`}>
      <div className="label-mono">{title}</div>
      <div className="mb-1 text-xs text-zinc-600" data-testid={`launch-${group}-name`}>{name ? `Following: ${name}` : "None added yet"}</div>
      <ol>
        {steps.map((s, i) => (
          <li key={s.key} className={`flex items-start gap-2 border-l-4 py-2 pl-2 ${i === next ? "border-black bg-zinc-50" : "border-transparent"}`}
              data-testid={`launch-${group}-${s.key}`} data-done={s.done ? "1" : "0"}>
            <span className={`mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center text-[10px] font-bold ${s.done ? "bg-emerald-600 text-white" : "border border-black"}`}>
              {s.done ? "✓" : i + 1}
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-bold leading-tight">
                {s.title}{i === next && <span className="ml-2 bg-black px-1.5 py-0.5 text-[9px] uppercase tracking-widest text-white">Next</span>}
              </div>
              <div className="text-xs text-zinc-600">{s.help}</div>
            </div>
            {!s.done && <StepAction s={s} group={group} onWizard={onWizard} />}
          </li>
        ))}
      </ol>
    </div>
  );
}
